import React from 'react';
import { Card, CardContent } from '../ui/card';

/**
 * Заглушка вместо виджета, чей источник данных не содержит колонок версий
 * (AppsFlyer: установки и cost, предрасчитанные ROAS-таблицы, роллапы agg_*).
 * Показывать такие данные без фильтра или с частичным фильтром нельзя —
 * цифры выглядели бы отфильтрованными, но не были бы ими.
 */
export default function VersionUnavailable() {
  return (
    <Card>
      <CardContent className="py-12 text-center space-y-2">
        <p className="text-base font-medium">Недоступно с фильтром версии</p>
        <p className="text-sm text-muted-foreground">
          Источник этих данных не хранит версию клиента. Снимите фильтры «Версия клиента» и
          «Версия установки», чтобы увидеть виджет.
        </p>
      </CardContent>
    </Card>
  );
}
